export default function findByKey(collection, value) {
  return collection.find(object => object.key === value)
}
